<template>
  <div class="pd-top-15">
    <page-layout
      :breadcrumbs="[
        {
          text: this.$t('navDrawer.home').toUpperCase(),
          disabled: false,
          to: {name: 'home'}
        },
        {
          text: this.$t('navDrawer.nuevaVisita').toUpperCase(),
          disabled: true
        },
        {
          text: this.$t('navDrawer.datosVisita').toUpperCase(),
          disabled: true
        }
      ]"
    >
      <v-expansion-panels v-model="panelDatos" id="panelDatos">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <o-expand-title class="pt-2">
              <slot name="title">
                {{localization.datosVisita.title + ' ' + ((getterVisita) ? getterVisita.visitaReferencia : '')}}
              </slot>
            </o-expand-title>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="">
            <v-row>
              <v-col cols="8">
                <v-row>
                  <v-col cols="6">
                    <v-row v-if="getterVisita" class="lineaSuperior sinPadding">
                      <v-col cols="4" class="bgAzul">
                        {{localization.datosVisita.promocion}}:
                      </v-col>
                      <v-col cols="8">
                        <span class="truncate-text">{{getterVisita.promocion}}</span>
                      </v-col>
                    </v-row>
                    <v-row v-if="getterVisita" class="sinPadding">
                      <v-col cols="4" class="bgAzul">
                        {{localization.datosVisita.provincia}}:
                      </v-col>
                      <v-col cols="8">
                        <span class="truncate-text">{{ getterVisita.promProvincia }}</span>
                      </v-col>
                    </v-row>
                    <v-row v-if="getterVisita" class="sinPadding">
                      <v-col cols="4" class="bgAzul">
                        {{localization.datosVisita.sector}}:
                      </v-col>
                      <v-col cols="8">
                        <span class="truncate-text">{{ getterVisita.sector }}</span>
                      </v-col>
                    </v-row>
                    <v-row v-if="getterVisita" class="sinPadding">
                      <v-col cols="4" class="bgAzul">
                        {{localization.datosVisita.inmueble}}:
                      </v-col>
                      <v-col cols="8">
                        {{allVisitIds.length > 1 ? 'SEGÚN SELECCIÓN' : rellenarInmueble()}}
                      </v-col>
                    </v-row>
                    <v-row v-if="getterVisita" class="sinPadding">
                      <v-col cols="4" class="bgAzul">
                        {{localization.datosVisita.direccion}}:
                      </v-col>
                      <v-col cols="8">
                        <span class="truncate-text">{{allVisitIds.length > 1 ? 'SEGÚN SELECCIÓN' : ((getterVisita.clienteEspecialPromocionId == null)?getterVisita.direccion:(getterVisita.promDireccion + (getterVisita.promDireccion.trim() != ''?', ':'') + getterVisita.promPoblacion + (getterVisita.promPoblacion.trim() != ''?', ':'') + getterVisita.promProvincia))}}</span>
                      </v-col>
                    </v-row>
                    <v-row v-if="getterVisita" class="sinPadding">
                      <v-col cols="4" class="bgAzul">
                        {{localization.datosVisita.poblacion}}:
                      </v-col>
                      <v-col cols="8">
                        <span class="truncate-text">{{ getterVisita.poblacion }}</span>
                      </v-col>
                    </v-row>
                    <v-row v-if="mostrarCPInmueble() && getterVisita" class="sinPadding">
                      <v-col cols="4" class="bgAzul">
                        {{this.getConfiguracion.codigoPropioNombre}}:
                      </v-col>
                      <v-col cols="8">
                        <span class="truncate-text">{{ getterVisita.valorCP }}</span>
                      </v-col>
                    </v-row>
                    <v-row v-if="getterVisita" class="sinPadding">
                      <v-col cols="4" class="bgAzul">
                        {{localization.datosVisita.tipoVisita}}:
                      </v-col>
                      <v-col cols="8">
                        {{rellenarTipoVisita()}}
                      </v-col>
                    </v-row>
                    <v-row v-if="getterVisita" class="sinPadding">
                      <v-col cols="4" class="bgAzul">
                        {{localization.datosVisita.fecha}}:
                      </v-col>
                      <v-col cols="8">
                        <span class="truncate-text">{{getterVisita.fecha}}</span>
                      </v-col>
                    </v-row>
                    <v-row v-if="getterVisita" class="sinPadding">
                      <v-col cols="4" class="bgAzul">
                        {{localization.datosVisita.reportadoPor}}:
                      </v-col>
                      <v-col cols="8">
                        <span class="truncate-text">{{getterVisita.reportadoPor}}</span>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="6">
                    <v-row v-if="getterVisita" class="lineaSuperior sinPadding">
                      <v-col cols="4" class="bgAzul">
                        {{localization.datosVisita.contacto}}:
                      </v-col>
                      <v-col cols="8">
                        {{nombreContacto}}
                      </v-col>
                    </v-row>
                    <v-row v-if="getterVisita" class="sinPadding">
                      <v-col cols="4" class="bgAzul">
                        {{localization.datosCliente.telefono}}:
                      </v-col>
                      <v-col cols="8">
                        {{telefonoContacto}}
                      </v-col>
                    </v-row>
                    <v-row v-if="getterVisita" class="sinPadding">
                      <v-col cols="4" class="bgAzul">
                        {{localization.datosCliente.movil}}:
                      </v-col>
                      <v-col cols="8">
                        {{movilContacto}}
                      </v-col>
                    </v-row>
                    <v-row v-if="getterVisita" class="sinPadding">
                      <v-col cols="4" class="bgAzul">
                        {{localization.datosCliente.email}}:
                      </v-col>
                      <v-col cols="8">
                        {{emailContacto}}
                      </v-col>
                    </v-row>
                    <v-row v-if="getterVisita" class="sinPadding">
                      <v-col cols="4" class="bgAzul">
                        {{localization.datosVisita.observaciones}}:
                      </v-col>
                      <v-col cols="8">
                        {{getterVisita.observacionesContacto}}
                      </v-col>
                    </v-row>

                    <v-row v-if="getterVisita && getConfiguracion.PV_VISITA_FECHA_ALTA_CLIENTE" class="sinPadding">
                      <v-col cols="4" class="bgAzul">
                        {{localization.datosVisita.altaInquilino}}:
                      </v-col>
                      <v-col cols="8">
                        {{getterVisita.fechaAltaCliente}}
                      </v-col>
                    </v-row>

                    <v-row v-if="getterVisita && getConfiguracion.PV_VISITA_REGISTRO_ENTRADA" class="sinPadding">
                      <v-col cols="4" class="bgAzul">
                        {{localization.datosVisita.registroEntrada}}:
                      </v-col>
                      <v-col cols="8">
                        {{getterVisita.numRegistro}}
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>

              <v-col align-self="end">
                <v-row v-if="imgFirma.length > 0" justify="end" align="start" class="pb-2 px-2 mr-2">
                  <span>{{localization.datosVisita.firma}}:
                    <v-img v-if="imgFirma.length > 0" contain
                      v-bind:src="'data:image/jpeg;base64,' + imgFirma[0].smallPicture"
                      width="200" height="150"></v-img>
                  </span>
                </v-row>
                <v-row class="pa-2 mr-2" justify="end">
                  <v-btn class="mr-8" :disabled="!permitirEnviarResumen" color="primary" @click="mostrarConfirmarResumen = true">
                    {{localization.datosVisita.enviarResumenButton}}
                  </v-btn>
                  <v-btn color="primary" @click="mostrarEditarVisita = true">
                    {{localization.datosVisita.editarVisitaButton}}
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-expansion-panels v-model="panelIncidencia" id="panelIncidencia" class="mt-4">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <o-expand-title class="pt-2">
              <slot name="title">
                {{localization.addSolicitud.title}}
              </slot>
            </o-expand-title>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-form v-model="valid" id="valid" ref="formIncidencia" autocomplete="off">
              <v-row no-gutters>
                <v-col cols="12" class="pr-8">
                  <v-row justify="start" no-gutters>
                    <v-col cols="3" class="px-2">
                      <v-autocomplete
                        v-model="codigoTipoSolicitud" id="codigoTipoSolicitud"
                        :items="tiposSolicitud"
                        :no-data-text="$t('sinDatos')"
                        :label="$t('sectionInformes.filtros.tipoSolicitud')"
                        :item-text="item => `${ item.translates[usuario.idioma] !== undefined ? item.translates[usuario.idioma] : item.descripcionTipoSolicitud  }`"
                        item-value="codigoTipoSolicitud"
                        :rules="[rules.obligatorio]"
                      />
                    </v-col>
                  </v-row>
                  <v-row justify="start" no-gutters v-if="codigoTipoSolicitud === '1'">
                    <v-col cols="3" class="px-2">
                      <v-autocomplete
                        v-model="parte" id="parte"
                        :no-data-text="$t('sinDatos')"
                        :items="getterOrderTypes"
                        :item-text="item => `${ item.translates && item.translates[usuario.idioma] !== undefined && item.translates[usuario.idioma] !== null ? item.translates[usuario.idioma] : item.name || '' }`"
                        item-value="id"
                        sort-by="code"
                        :label="textoCampoComprobarObligatorio(localization.addSolicitud.tipoParte, 'Parte')"
                        clearable
                        :rules="(comprobarObligatorio('Parte') && getterOrderTypes.length !== 0) ? [rules.obligatorio] : []"
                      />
                    </v-col>
                    <v-col cols="3" class="px-2">
                      <v-autocomplete
                        v-model="urgencia" id="urgencia"
                        :no-data-text="$t('sinDatos')"
                        :items="getterUrgencias"
                        :label="textoCampoComprobarObligatorio(localization.addSolicitud.urgencia, 'Urgencia')"
                        :item-text="item => `${ item.translates && item.translates[usuario.idioma] !== undefined && item.translates[usuario.idioma] !== null ? item.translates[usuario.idioma] : item.name || '' }`"
                        item-value="value"
                        clearable
                        :rules="(comprobarObligatorio('Urgencia') && getterUrgencias.length !== 0) ? [rules.obligatorio] : []"
                      />
                    </v-col>
                    <v-col cols="3" class="px-2">
                      <v-autocomplete
                        v-model="tipoRec" id="tipoRec"
                        :no-data-text="$t('sinDatos')"
                        :items="getterComplaintTypes"
                        :item-text="item => `${ item.translates && item.translates[usuario.idioma] !== undefined && item.translates[usuario.idioma] !== null ? item.translates[usuario.idioma] : item.name || '' }`"
                        item-value="id"
                        sort-by="code"
                        :label="textoCampoComprobarObligatorio(localization.addSolicitud.tipoReclamacion, 'Tipo Reclamación')"
                        multiple
                        clearable
                        :rules="(comprobarObligatorio('Tipo Reclamación') && getterComplaintTypes.length !== 0) ? [rules.required] : []"
                      />
                    </v-col>

                  </v-row>
                  <v-row justify="start" no-gutters v-if="codigoTipoSolicitud === '1'" >
                    <v-col cols="3" class="px-2">
                      
                      <v-autocomplete
                        v-model="localizacion" id="localizacion"
                        :no-data-text="$t('sinDatos')"
                        :items="getterLocalizaciones"
                        :item-text="mostrarIdioma"
                        item-value="id"
                        sort-by="code"
                        :disabled="tieneClienteEspecial"
                        :label="(tieneClienteEspecial) ? 'Localización' : textoCampoComprobarObligatorio(localization.addSolicitud.localizacion, 'Localización')"
                        clearable
                        :rules="(!tieneClienteEspecial && comprobarObligatorio('Localización') && getterLocalizaciones.length !== 0) ? [rules.obligatorio] : []"
                      />
                    </v-col>
                    <v-col cols="3" class="px-2">
                      <v-autocomplete
                        v-model="oficio" id="oficio"
                        :no-data-text="$t('sinDatos')"
                        :items="getterOficios"
                        :item-text="mostrarIdioma"
                        item-value="value"
                        sort-by="code"
                        clearable
                        autocomplete="disabled"
                        :label="textoCampoComprobarObligatorio(localization.addSolicitud.oficio, 'Oficio')"
                        :rules="(comprobarObligatorio('Oficio') && getterOficios.length !== 0) ? [rules.obligatorio] : []"
                      />
                    </v-col>
                    <v-col cols="3" class="px-2">
                      <v-autocomplete
                        v-model="suboficio" id="suboficio"
                        :no-data-text="$t('sinDatos')"
                        :items="getterSuboficios"
                        :item-text="mostrarIdioma"
                        item-value="value"
                        sort-by="code"
                        :label="textoCampoComprobarObligatorio(localization.addSolicitud.suboficio, 'Suboficio')"
                        :disabled="oficio === null"
                        clearable
                        autocomplete="disabled"
                        @click:clear="$nextTick(() => suboficio = null)"
                        :rules="(comprobarObligatorio('Suboficio') && getterSuboficios.length !== 0) ? [rules.obligatorio] : []"
                      />
                    </v-col>
                    <!-- getterPredefinedIncidencesByProfession -->
                    <v-col cols="3" class="px-2">
                      <v-autocomplete
                        v-model="predefinida" id="predefinida"
                        :no-data-text="$t('sinDatos')"
                        :items="getterPredefinedIncidencesByProfession"
                        :item-text="mostrarIdioma"
                        item-value="id"
                        sort-by="code"
                        :label="textoCampoComprobarObligatorio(localization.addSolicitud.predefinida, 'Predefinida')"
                        :disabled="oficio === null"
                        clearable
                        :rules="(comprobarObligatorio('Predefinida') && getterPredefinedIncidencesByProfession.length !== 0 && oficio != null) ? [rules.obligatorio] : []"
                      />
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col class="px-2">
                      <!-- <v-text-field
                        v-model="descripcion" id="descripcion"
                        :label="textoCampoComprobarObligatorio(localization.addSolicitud.descripcion, 'Descripción')"
                        :rules="comprobarObligatorio('Descripción') ? [rules.obligatorio] : []"
                      /> -->
                      <v-textarea
                        v-model="descripcion" id="descripcion"
                        rows="3"
                        row-height="15"
                        :label="textoCampoComprobarObligatorio(localization.addSolicitud.descripcion, 'Descripción')"
                        :rules="comprobarObligatorio('Descripción') ? [rules.obligatorio] : []"
                      />
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col class="px-2">
                      <!-- <v-text-field
                        v-model="observaciones" id="observaciones"
                        :label="localization.addSolicitud.observaciones"
                      /> -->
                      <v-textarea
                        v-model="observaciones" id="observaciones"
                        rows="3"
                        row-height="15"
                        :label="localization.addSolicitud.observaciones"
                      />
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="3" class="px-2">
                      <v-checkbox
                        v-model="reincidente" id="reincidente"
                        color="primary"
                        :label="localization.addSolicitud.reincidente"
                      />
                    </v-col>
                    <v-col v-if="estadoRechazado" cols="3" class="px-2">
                      <v-checkbox
                        v-model="rechazada" id="rechazada"
                        color="primary"
                        :label="localization.addSolicitud.rechazada"
                      />
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="3" class="px-2">
                      <o-date-picker
                        v-model="fechaAviso" id="fechaAviso"
                        :label="localization.addSolicitud.fechaAviso"
                        :clearable="true"
                      />
                    </v-col>
                    <v-col cols="3" class="px-2">
                      <o-date-picker
                        v-model="fechaFin" id="fechaFin"
                        :label="textoCampoComprobarObligatorio(localization.addSolicitud.fechaFinPrevisto, 'Fin Previsto')"
                        :obligatorio="comprobarObligatorio('Fin Previsto')"
                        :clearable="true"
                      />
                    </v-col>
                    <v-col cols="3">
                      &nbsp;
                    </v-col>
                    <v-col cols="3" class="px-2">
                      <v-autocomplete
                        v-model="responsable" id="responsable"
                        :no-data-text="$t('sinDatos')"
                        :items="responsables"
                        item-text="nombreCompleto"
                        item-value="id"
                        :label="textoCampoComprobarObligatorio(localization.addSolicitud.responsable, 'Responsable')"
                        clearable
                        :rules="(comprobarObligatorio('Responsable') && responsables.length !== 0) ? [rules.obligatorio] : []"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
            <v-col align-self="end">
              <v-row class="pa-2 mr-2" justify="end">
                <v-btn color="primary" @click="createIncidencia()">
                  {{localization.addSolicitud.button}}
                </v-btn>
              </v-row>
            </v-col>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-expansion-panels v-model="panelTabla" id="panelTabla" class="mt-4">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <o-expand-title class="pt-2">
              <slot name="title">
                {{localization.resumenSolicitudes.title}}
              </slot>
            </o-expand-title>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row justify="center" align="center" class="px-6">
              <v-data-table
                :headers="headers"
                :search="search"
                style="width:100%"
                :items="getIncidenceFromListNumber"
                item-key="inmuebleId"
                locale="es"
                :footer-props="{
                  'items-per-page-options': [5, 10, 15, 20],
                  'items-per-page-text': $t('filasPorPagina'),
                }"
              >
                <!-- <template v-slot:item.description="{ item }">
                  {{item.description}}
                </template> -->
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr
                      v-for="item in items"
                      :key="item.id"
                    >
                      <td class="text-xs-center">{{ item.codigoTipoSolicitud }}</td>
                      <!--<td class="text-xs-center">{{ item.id }}</td>-->
                      <td class="text-xs-center">{{ item.referencia }}</td>
                      <td class="text-xs-center">{{ getState(item) }}</td>
                      <td class="text-xs-center">{{ traducirLocalizacion(item) }}</td>
                      <td class="text-xs-center recortarStyle">{{ item.description }}</td>
                      <td class="text-xs-center">{{ traducirOficio(item) }}</td>
                      <td class="text-xs-center">{{ item.openDate }}</td>
                      <td class="text-xs-center">{{ item.notificationDate }}</td>
                      <td class="text-xs-center">{{ item.closeDate }}</td>
                      <td class="text-xs-center">
                        <v-row justify="end">
                          <v-btn icon color="primary"
                            @click="editarIncidencia(item.id)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn v-if="!rolProveedor && idubapi.restriccionesCliente.restringirAccesoEliminarIncidenciasPV != 1" icon color="primary"
                            @click="deleteItem(item.id)"
                          >
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </v-row>
                      </td>
                    </tr>
                  </tbody>
                </template>
                <!-- <template v-slot:item.acciones="{ item }">
                  <v-btn icon color="primary"
                    @click="editarIncidencia(item.id)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn icon color="primary"
                    @click="deleteItem(item.id)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template> -->
              </v-data-table>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <ConfirmDialog @close="confirmarBorrado()" :text="textoConfirmacion"
            @cancel="dialogDelete = false" :dialogFlag="dialogDelete"
            :textoTitulo="$t('eliminar')" :textoBoton="$t('eliminar')" />
      <v-fade-transition>
        <custom-dialog
          v-if="mostrarEditarVisita"
          v-model="mostrarEditarVisita" id="mostrarEditarVisita"
          @aceptar="mostrarEditarVisita = $event"
        >
          <PopUpEditarVisita
            :visita="getterVisita"
            @recargar="load"
          />
        </custom-dialog>
      </v-fade-transition>
      <v-fade-transition>
        <PopUpSeguro
          v-if="mostrarConfirmarResumen"
          @aceptar="enviarResumen"
          :titulo=localization.resumenSolicitudes.enviarResumen
          :pregunta=localization.resumenSolicitudes.deseaEnviarResumen
          :alerta="''"
          :descartar=localization.resumenSolicitudes.enviar
          :cancelar=localization.resumenSolicitudes.cancelar
          :esResumen="true"
        />
      </v-fade-transition>

      <v-fade-transition>
        <PopUpSeguro
          v-if="mostrarModalAntesDeSalir"
          @aceptar="enviarResumenSupervisores"
          :titulo=localization.resumenSolicitudes.enviarResumenSupervisores
          :pregunta=localization.resumenSolicitudes.solicitudesAñadidas
          :alerta="''"
          :descartar=localization.resumenSolicitudes.siEnviarResumen
          :cancelar=localization.resumenSolicitudes.noEnviarResumen
          :esResumen="true"
        />
      </v-fade-transition>

    </page-layout>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import rulesMixin from '@/components/generic/rules.js'
import ConfirmDialog from '../custom/confirmDialog'
import PopUpEditarVisita from './PopUpEditarVisita'
import PopUpSeguro from '@/components/generic/popups/PopUpSeguro'

export default {
  mixins: [rulesMixin],
  components: {
    ConfirmDialog,
    PopUpEditarVisita,
    PopUpSeguro
  },
  props: {
    actualVisitId: {
      type: String,
      required: true
    },
    allVisitIds: {
      type: Array,
      default: () => []
    },
    codigoSolicitudEnRuta: {
      type: String,
      default: '1'
    }
  },
  data () {
    return {
      hayTipoIncidencia: {
        codigoTipoSolicitud: '0'
      },
      valid: false,
      panelDatos: 0,
      panelIncidencia: 0,
      panelTabla: 0,
      codigoTipoSolicitud: '1',
      localizacion: null,
      oficio: null,
      suboficio: null,
      predefinida: null,
      parte: null,
      tipoRec: null,
      descripcion: null,
      observaciones: null,
      responsable: null,
      fechaFin: null,
      menuFin: false,
      fechaAviso: moment().format('YYYY-MM-DD'),
      menuAviso: false,
      reincidente: false,
      rechazada: false,
      loader: null,
      search: null,
      dialogDelete: false,
      textoConfirmacion: '',
      itemId: [],
      mostrarEditarVisita: false,
      mostrarConfirmarResumen: false,
      permitirEnviarResumen: false,
      urgencia: null,
      clienteEspecial: {},
      tieneClienteEspecial: false,
      visitasAnadidas: false
    }
  },
  async created () {
    this.loader = this.$loading.show({
      // Optional parameters
      container: this.fullPage ? null : this.$refs.formContainer,
      canCancel: false,
      onCancel: this.onCancel
    })
    await this.load()
    this.inicializar()
  },
  computed: {
    ...mapGetters({
      getterVisita: 'incidencias/getVisita',
      getterSuboficios: 'incidencias/getSuboficios',
      getterPredefinedIncidencesByProfession: 'incidencias/getPredefinedIncidencesByProfession',
      getterComplaintTypes: 'incidencias/getComplaintTypes',
      getterOrderTypes: 'incidencias/getOrderTypes',
      getterResponsables: 'incidencias/getResponsables',
      getterLocalizaciones: 'incidencias/getLocations',
      getIncidenceFromListNumber: 'incidencias/getIncidenceFromListNumber',
      getConfiguracion: 'configuracion/getConfiguracion',
      getterOficios: 'incidencias/getOficios',
      tiposSolicitud: 'configuracion/getTiposSolicitud',
      getterUrgencias: 'incidencias/getUrgencias',
      getRutaAnulada: 'getRutaAnulada',
      idubapi: 'login/idubapi',
      rolProveedor: 'login/rolProveedor',
      rolCliente: 'login/rolCliente'
    }),
    usuario() {
      return JSON.parse(localStorage.getItem('usuario'))
    },
    translates() {
      if (this.$store.state.tiposSolicitud.translates) {
        return this.$store.state.tiposSolicitud.translates;
      }
      return [];
    },
    visitIdsString () {
      return this.allVisitIds.join('-')
    },
    localization () {
      return this.$t('datosVisita')
    },
    headers () {
      return [
        {text: this.localization.resumenSolicitudes.tipoSolicitud, value: 'codigoTipoSolicitud', align: 'left'},
        {text: this.localization.resumenSolicitudes.incidencia, value: 'id', align: 'left'},
        {text: this.localization.resumenSolicitudes.estado, value: 'state', sortable: true, align: 'left'},
        {text: this.localization.resumenSolicitudes.localizacion, value: 'room', sortable: true, align: 'left'},
        {text: this.localization.resumenSolicitudes.descripcion, value: 'description', sortable: true, align: 'left'},
        {text: this.localization.resumenSolicitudes.oficio, value: 'profession', sortable: true, align: 'left'},
        {text: this.localization.resumenSolicitudes.entrada, value: 'openDate', sortable: true, align: 'left'},
        {text: this.localization.resumenSolicitudes.aviso, value: 'notificationDate', sortable: true, align: 'left'},
        {text: this.localization.resumenSolicitudes.cierre, value: 'closeDate', sortable: true, align: 'left'},
        {text: this.localization.resumenSolicitudes.acciones, value: 'acciones', sortable: false, align: 'right'}
      ]
    },
    imgFirma () {
      if (this.$store.state.incidencias.imgFirma) {
        return this.$store.state.incidencias.imgFirma
      }
      return []
    },
    responsables () {
      return this.getterResponsables.map(x => {
        return {
          ...x,
          nombreCompleto: x.nombre + ' ' + x.apellidos
        }
      })
    },
    camposObligatorios () {
      return this.getConfiguracion.camposObligatorios
    },
    estadoRechazado () {
      return this.getConfiguracion.permitirIncidenciasRechazado
    },
    fechaFinFormated () {
      return (this.fechaFin) ? moment(this.fechaFin, 'YYYY-MM-DD').format('DD/MM/YYYY') : null
    },
    fechaAvisoFormated () {
      return (this.fechaAviso) ? moment(this.fechaAviso, 'YYYY-MM-DD').format('DD/MM/YYYY') : null
    },
    emailContacto() {
      if(this.getterVisita.emailContacto) {
        return this.getterVisita.emailContacto
      } else {
        if(this.tieneClienteEspecial) {
          return this.clienteEspecial.email
        } else {
          return this.getterVisita.emailCliente
        }
      }
    },
    telefonoContacto() {
      if(this.getterVisita.telefonoContacto) {
        return this.getterVisita.telefonoContacto
      } else {
        if(this.tieneClienteEspecial) {
          return this.clienteEspecial.telefono
        } else {
          return this.getterVisita.telefonoCliente
        }
      }
    },
    movilContacto() {
      if(this.getterVisita.movilContacto) {
        return this.getterVisita.movilContacto
      } else {
        if(this.tieneClienteEspecial) {
          return this.clienteEspecial.movil
        } else {
          return this.getterVisita.movilCliente
        }
      }
    },
    nombreContacto() {
      if(this.getterVisita.nombreContacto) {
        return this.getterVisita.nombreContacto
      } else {
        if(this.tieneClienteEspecial) {
          return this.clienteEspecial.nombre
        } else {
          return this.getterVisita.nombre
        }
      }
    },
    mostrarModalAntesDeSalir () {
      return this.$store.state.incidencias.mostrarModalAntesDeSalir;
    },
    specialPropTypes () {
      if (this.$store.state.incidencias.specialPropTypes) {
        return this.$store.state.incidencias.specialPropTypes
      }
      return []
    },
    visitTypes () {
      if (this.$store.state.incidencias.tipoVisita) {
        return this.$store.state.incidencias.tipoVisita
      }
      return []
    },
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      getVisit: 'incidencias/getVisit',
      getSuboficios: 'incidencias/getSuboficios',
      getPredefinedIncidencesByProfession: 'incidencias/getPredefinedIncidencesByProfession',
      getComplaintTypes: 'incidencias/getComplaintTypes',
      getOrderTypes: 'incidencias/getOrderTypes',
      getResponsables: 'incidencias/getResponsables',
      getLocalizaciones: 'incidencias/getLocalizaciones',
      getOficios: 'incidencias/getOficios',
      getIncidenciasByVisita: 'incidencias/getIncidenciasByVisita',
      loadConfiguracion: 'configuracion/obtenerConfiguracion',
      addIncidence: 'incidencias/addIncidence',
      delIncidencias: 'incidencias/delIncidencias',
      realizarEnvioResumen: 'incidencias/realizarEnvioResumen',
      getImgFirma: 'incidencias/getImgFirma',
      getUrgencias: 'incidencias/getUrgencias',
      getClientesEspecialesPromocionByIdPromocion: 'incidencias/getClientesEspecialesPromocionByIdPromocion',
      ocultarPopupConfirmar: 'incidencias/ocultarPopupConfirmar',
      cambiarVisitaModificada: 'incidencias/cambiarVisitaModificada',
      guardarRutaAnulada: 'guardarRutaAnulada',
      getEstados: 'incidencias/getStatusTypes',
      getSpecialPropertyTypes: 'incidencias/getSpecialPropertyTypes',
      getVisitTypes: 'incidencias/getVisitTypes',
    }),
    callImgFirma () {
      if(!this.getterVisita) return
      const values = {
        objetoId: this.getterVisita.idVisita,
        tipoObjetoId: '3',
        carpetaId: '2'
      }
      this.getImgFirma(values)
    },
    inicializar () {
      if(!this.getterVisita ) return
      this.visitId = this.getterVisita.idVisita
      this.visitReferencia = this.getterVisita.visitReferencia
      this.codigoTipoSolicitud = this.codigoSolicitudEnRuta ? this.codigoSolicitudEnRuta : '1'
      this.localizacion = null
      this.oficio = null
      if(this.rolProveedor && this.getterOficios.length == 1){
        this.oficio = this.getterOficios[0].value
      }
      this.suboficio = null
      this.predefinida = null
      this.parte = null
      this.tipoRec = null
      this.descripcion = null
      this.observaciones = null
      this.responsable = this.$store.state.login.credentials.id_actor
      this.fechaFin = this.getConfiguracion.diasRegistroCierre == null
        ? moment().add(30, 'days').format('YYYY-MM-DD')
        : moment().add(this.getConfiguracion.diasRegistroCierre, 'days').format('YYYY-MM-DD')
      this.fechaAviso = moment().format('YYYY-MM-DD')
      this.reincidente = false
      this.rechazada = false
    },
    async createIncidencia () {
      this.$refs.formIncidencia.validate()
      if (!this.valid) {
        this.addAlert({texto: this.$t("revisarCamposRojo") , color: 'error'})
      } else {
        try {
          this.loader = this.$loading.show({
            // Optional parameters
            container: this.fullPage ? null : this.$refs.formContainer,
            canCancel: false,
            onCancel: this.onCancel
          })
          if (this.allVisitIds.length === 0) {
            this.allVisitIds.push(this.actualVisitId)
          }
          await Promise.all(this.allVisitIds.map(async x => {
            let newIncidence = {
              codigoTipoSolicitud: this.codigoTipoSolicitud,
              proffesionId: this.oficio,
              proffesion2Id: this.suboficio,
              description: this.descripcion,
              obs: this.observaciones,
              complaint: this.tipoRec,
              predefinedIncidenceId: this.predefinida,
              recidivist: this.reincidente ? '1' : '0',
              orderTypeId: this.parte,
              roomId: this.localizacion,
              initialFinishDate: this.fechaFin,
              providerId: (this.rolProveedor) ? this.idubapi.PERMISOS_ROL_PROVEEDOR_WEB.ID_PROVEEDOR : null,
              severityId: this.urgencia,
              responsableId: this.responsable,
              notificationDate: this.fechaAviso,
              statusId: this.rechazada ? '90' : '10',
              visitId: x,
              visitReferencia: x,
              rolCliente: this.rolCliente
            }
            await this.addIncidence(newIncidence)
          }))
          let envioMailAutomaticoSupervisor = this.getConfiguracion.PV_WEB_ENVIO_RESUMEN_SUPERVISOR
          if(!this.visitasAnadidas && envioMailAutomaticoSupervisor) {
            this.cambiarVisitaModificada()
            this.visitasAnadidas = true
          }
          await this.load()
          this.$refs.formIncidencia.resetValidation()
          this.inicializar()
          this.addAlert({texto: this.$t('nuevaIncidenciaCreada'), color: 'success'})
          this.loader.hide()
        } catch (error) {
          this.loader.hide()
          this.addAlert({ texto: this.$t('errorCrearNuevaIncidencia') + error.message, color: 'error' })
        }
      }
    },
    async load () {
      try {
        if (this.allVisitIds.length === 0) {
          this.allVisitIds.push(this.actualVisitId)
        }
        await this.getVisit(this.actualVisitId)
        // agrupamos todas las promises
        let promises = [
          this.loadConfiguracion(),
          this.getComplaintTypes(),
          this.getOrderTypes(),
          this.getResponsables(),
          this.getUrgencias(),
          this.getEstados(),
          this.getSpecialPropertyTypes(),
          this.getVisitTypes(),
          this.getIncidenciasByVisita(this.visitIdsString),
          this.getOficios({
            providerId: (this.rolProveedor) ? this.idubapi.PERMISOS_ROL_PROVEEDOR_WEB.ID_PROVEEDOR : null,
          }),
          this.callImgFirma()
        ]

        
        if(this.getterVisita && this.getterVisita.clienteEspecialPromocionId !== null) {
          promises.push(this.getClientesEspecialesPromocionByIdPromocion(this.getterVisita.promocionId)
            .then(response => {
              let clientesEspeciales = response.data.data
              this.clienteEspecial = clientesEspeciales.find(x => x.id == this.getterVisita.clienteEspecialPromocionId)
              this.tieneClienteEspecial = true
            })
          )
        }

        console.log(this.getterVisita)

        await Promise.all(promises)
        setTimeout(async () => {
          await this.getLocalizaciones(this.getterVisita.tipoInmuebleId)
        }, 100)
        
        /*
        await this.getVisit(this.actualVisitId)
        await this.loadConfiguracion()
        await this.getComplaintTypes()
        await this.getOrderTypes()
        await this.getResponsables()
        await this.getUrgencias()
        await this.getEstados()
        await this.getLocalizaciones(this.getterVisita.tipoInmuebleId)
        await this.getSpecialPropertyTypes()
        await this.getVisitTypes()
        */
        /* if (this.allVisitIds.length === '1') {
          await this.getIncidenciasByVisita(this.allVisitIds)
        }else {
          await this.getIncidenciasByVisita(this.visitIdsString)
        } */
        

        this.loader.hide()
        return true;
      } catch (error) {
        console.log(error)
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
        this.loader.hide()
      }
    },
    confirmarBorrado () {

      this.loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false
      })

      this.delIncidencias(this.itemId)
        .then(() => {
          this.load()
          this.dialogDelete = false
        })
        .catch(e => {
          this.loader.hide()
          this.addAlert({texto: e.message, color: 'error'})
          this.dialogDelete = false
        })
    },
    deleteItem (itemId) {
      this.textoConfirmacion = this.$t('seguroEliminarElemento')
      this.dialogDelete = true
      this.itemId = [itemId]
    },
    comprobarObligatorio (text) {
      if (this.camposObligatorios) {
        return this.camposObligatorios.some(x => x === text)
      }
      return false
    },
    textoCampoComprobarObligatorio (texto, tipo) {
      return texto + (this.comprobarObligatorio(tipo) ? '*' : '')
    },
    formatDate (date) {
      return moment(date).format('DD-MM-YYYY')
    },
    editarIncidencia (itemId) {
      this.$router.push({ path: `/solicitudes/${itemId}` })
    },

    async enviarResumen (aceptado, idioma) {
      this.mostrarConfirmarResumen = false
      if (aceptado) {
        try {
          this.loader = this.$loading.show({
            // Optional parameters
            container: this.fullPage ? null : this.$refs.formContainer,
            canCancel: false,
            onCancel: this.onCancel
          })
          await this.realizarEnvioResumen({
            visitId: this.actualVisitId,
            supervisores: false,
            idioma: idioma
          })
          this.loader.hide()
          this.addAlert({texto: this.$t('resumenEnviado'), color: 'success'})
        } catch (error) {
          if (!error.code || error.code !== 1) {
            this.addAlert({texto: error.message, color: 'error'})
          }
          this.loader.hide()
        }
      }
    },
    async enviarResumenSupervisores (aceptado, idioma) {
      this.ocultarPopupConfirmar();
      this.cambiarVisitaModificada();
      const rutaAnulada = this.getRutaAnulada

      this.guardarRutaAnulada(null)
      if (aceptado) {
        try {
          this.loader = this.$loading.show({
            // Optional parameters
            container: this.fullPage ? null : this.$refs.formContainer,
            canCancel: false,
            onCancel: this.onCancel
          })
          await this.realizarEnvioResumen({
            visitId: this.actualVisitId,
            supervisores: true,
            idioma: idioma
          })
          this.loader.hide()
          this.addAlert({texto: this.$t('resumenEnviado'), color: 'success'})
          this.$router.push({path: rutaAnulada})
        } catch (error) {
          if (!error.code || error.code !== 1) {
            this.addAlert({texto: error.message, color: 'error'})
          }
          this.loader.hide()
        }
      } else {
        if(rutaAnulada !== null) {
          this.$router.push({path: rutaAnulada})
        }
      }
    },
    mostrarCPInmueble () {
      return this.getConfiguracion.codigoPropioNombre !== 'NFORMACIÓN ADICIONAL'
    },
    getState ( item ) {
      var estados = this.$store.state.incidencias.estados
      var estado = estados.find( o => o.id === item.stateId) 
      return estado.translates[this.usuario.idioma]
    },
    traducirLocalizacion (item) {
      if(item.idEstancia) {
        let localizacion = this.getterLocalizaciones.find(x => {
          return x.id == item.idEstancia
        })
        if(localizacion) {
          return localizacion.translates[this.usuario.idioma]
        } else {
          return null
        }
      } else 
        return null
      
    },
    traducirOficio (item) {
      if(item.idOficio) {
        let oficio = this.getterOficios.find(x => {
          return x.value == item.idOficio
        })
        if(oficio) {
          return oficio.translates[this.usuario.idioma]
        } else {
          return null
        }
      } else 
        return null
      
    },
    rellenarInmueble() {
      let inmuEspecial = this.specialPropTypes.find(item => {
        return item.id == this.getterVisita.idInmuebleEspecial
      })
      if(inmuEspecial) {
        if(inmuEspecial.translates && inmuEspecial.translates[this.usuario.idioma]) {
          return inmuEspecial.translates[this.usuario.idioma]
        } else {
          return (this.getterVisita.uhedit ? this.getterVisita.uhedit : this.getterVisita.tipoInmuebleEspecial)
        }
      } else {
        return (this.getterVisita.uhedit ? this.getterVisita.uhedit : this.getterVisita.tipoInmuebleEspecial)
      }
      
    },
    rellenarTipoVisita() {
      let tipoVisita = this.visitTypes.find(item => {
        return item.name == this.getterVisita.tipoVisita
      })
      if(tipoVisita) {
        if(tipoVisita.translates && tipoVisita.translates[this.usuario.idioma]) {
          return tipoVisita.translates[this.usuario.idioma]
        } else {
          return this.getterVisita.tipoVisita
        }
      } else {
        return this.getterVisita.tipoVisita
      }
      
    },
    mostrarIdioma (item) {
      if (item.translates && item.translates[this.usuario.idioma] && item.translates[this.usuario.idioma].length > 0 ) {
        return item.translates[this.usuario.idioma]
      } else {
        return item.name || item.description || item.text || ''
      }
    },
  },
  watch: {
    oficio () {
      this.getSuboficios(this.oficio)
      this.getPredefinedIncidencesByProfession({professionId: this.oficio, subProfessionId: this.suboficio})
    },
    suboficio () {
      this.getPredefinedIncidencesByProfession({professionId: this.oficio, subProfessionId: this.suboficio})
    },
    getIncidenceFromListNumber () {
      if (this.getIncidenceFromListNumber !== undefined) {
        this.permitirEnviarResumen = this.getIncidenceFromListNumber.length > 0
      } else {
        this.permitirEnviarResumen = false
      }

    },
    codigoTipoSolicitud () {
      this.oficio = null
      this.suboficio = null
      this.localizacion = null
      this.predefinida = null
    }
  }
}
</script>

<style scoped>
.bigContainer {
  height: 90vh;
}

.recortarStyle {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 120px;
  }

.bgAzul {
  background-color: #1976d2;
  color: white;
}
.lineaSuperior {
  border-top: solid 1px #1976d2;
}

.sinPadding div {
  padding: 0px;
  padding-left: 5px;
}
.truncate-text {
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 80%; /* your width */
    display: block;
    overflow: hidden
}
</style>
